import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/** Distinct merchants owning at least one inventory config, for the filter. */
export const getSuppliesInventoryConfigMerchants = unaryRpc({
  name: "getSuppliesInventoryConfigMerchants" as const,
  input: z.object({}),
  output: z.object({
    merchants: z.array(z.object({ teamId: z.string(), name: z.string() })),
  }),
});
